import { useTranslation } from "react-i18next";
import Step from "./step";
import AuthContext from "../../auth-context";
import { useContext, useEffect, useState } from "react";
import ChangeNumberApi from "../../../api/change-sim-card";

export interface IStepProgressProps {
  step: number;
  type?: number;
  steps: number[];
}

export default function StepProgress({
  step,
  type,
  steps,
}: IStepProgressProps) {
  const { t } = useTranslation(undefined, { keyPrefix: "SignUp" });
  const context = useContext(AuthContext);
  const [hasAccess, setHasAccess] = useState(false);

  useEffect(() => {
    const fetchAccess = async () => {
      const changeNumberApi = new ChangeNumberApi(context);
      const access = await changeNumberApi.get();
      console.log("access", access);
      setHasAccess(access);
    };

    fetchAccess();
  }, []);

  return (
    <div className="w-full rtl text-center m-auto pt-12 sm:!w-[70%]">
      <div className="flex">
        <Step
          step={1}
          title={t("General Info")}
          isActive={step > 0}
          steps={steps}
        />
        <Step
          step={2}
          title={t("Cell Number Confirmation")}
          isActive={step > 1}
          steps={steps}
        />
        <Step
          step={3}
          title={t("Upload NationalCartImage")}
          isActive={step > 2}
          steps={steps}
        />

        {type === 40 ? (
          <>
            <Step
              step={4}
              title={t("Select Line")}
              isActive={step > 3}
              steps={steps}
            />
            <Step
              step={5}
              title={t("Purchase Service")}
              isActive={step > 4}
              steps={steps}
            />
            <Step
              step={6}
              title={t("Payment")}
              isActive={step > 5}
              steps={steps}
            />
            {hasAccess && (
              <Step
                step={7}
                title={t("ChangeNumber")}
                isActive={step > 6}
                steps={steps}
                lastStep
              />
            )}
          </>
        ) : (
          <>
            <Step
              step={4}
              title={t("Purchase Service")}
              isActive={step > 3}
              steps={steps}
            />
            <Step
              step={5}
              title={t("Payment")}
              isActive={step > 4}
              steps={steps}
            />
            {hasAccess && (
              <Step
                step={6}
                title={t("ChangeNumber")}
                isActive={step > 5}
                steps={steps}
                lastStep
              />
            )}
          </>
        )}
      </div>
    </div>
  );
}
